import React from "react";
import Modal, { Props } from "@ff/ui/Modal";

export default function CustomizedModal(props: Props){
  const newProps = {
    ...props,
    closeIconProps: {
    width: '30px',
    height: '30px',
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '30px',
    background: 'rgba(116, 116, 128, 0.08)',
    color: 'rgba(60, 60, 67, 0.6)' as any,
    borderRadius: '100px',
  },
  backdrop: true,
  closeIcon: true,
  closeOnBackdrop: true,
}

  return(
    <Modal {...newProps}>
      {newProps.children}
    </Modal>
  );
}